var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeDarkNotAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 28,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 22C25.3137 22 28 19.3137 28 16C28 12.6863 25.3137 10 22 10C18.6863 10 16 12.6863 16 16C16 19.3137 18.6863 22 22 22ZM18.9211 17.8667C18.5904 17.3224 18.4 16.6834 18.4 16C18.4 14.0118 20.0118 12.4 22 12.4C22.6834 12.4 23.3224 12.5904 23.8667 12.9211L18.9211 17.8667ZM20.1333 19.0788C20.6776 19.4096 21.3166 19.6 22 19.6C23.9882 19.6 25.6 17.9882 25.6 16C25.6 15.3166 25.4096 14.6776 25.0788 14.1333L20.1333 19.0788Z",
    fill: "#38ac68",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeDarkNotAllowed);
export default __webpack_public_path__ + "static/media/we-dark-not-allowed.22dafda6c13925cc7a5996c9d30efda4.svg";
export { ForwardRef as ReactComponent };